import React, { useContext } from 'react';
import useFields, { FieldTypes } from '@ubeya/shared/hooks/account/useFields';
import { EMPLOYEE_FIELD_LEVEL, formatLevelOption } from '../../../utils/employee';
import ConfigContext from '../../../contexts/ConfigContext';

const FieldChip = ({ id: fieldId, value }) => {
  const { mappedFieldsValue, mappedFields } = useFields();
  const { t, distanceUnitShortTranslationKey } = useContext(ConfigContext);

  if (!!mappedFields[fieldId]?.fieldTypeId && mappedFields[fieldId].fieldTypeId === FieldTypes.FIELD_TYPE_ADDRESS) {
    const content = `${mappedFieldsValue[fieldId]?.(value)} ${t(distanceUnitShortTranslationKey)} ${
      value.address && `${t('fromLocation')} ${value.address}`
    }`;
    return <>{content}</>;
  }

  if (fieldId === EMPLOYEE_FIELD_LEVEL) {
    const levels = Array.isArray(value) ? value : [value];
    return <>{levels.map((item) => formatLevelOption({ t, level: mappedFieldsValue[fieldId]?.(item) })).join(', ')}</>;
  }

  return <>{mappedFieldsValue[fieldId]?.(value)}</>;
};

export default FieldChip;
